import axios from "../api";
/**
 * My Club's best possible squad: every formation, players from the user's own
 * club only. The backend builds the request itself; the first one is free
 * (it ticks MY_CLUB_ONBOARDING_SHOW_BEST), later ones cost a credit.
 */
export const buildBestClubSquad = async () => {
    const res = await axios.post("/squad-builder/my-club-best-squad");
    return res.data;
};
//# sourceMappingURL=buildBestClubSquad.js.map